<div class="auth-card animate__animated animate__fadeIn">
  <div class="auth-card-header">
    <h2>Reenviar PIN</h2>
  </div>

  <form [formGroup]="form" (ngSubmit)="resendPin()" class="auth-form">
    <div class="form-group">
      <label>Email</label>
      <div class="input-wrapper">
        <i class="fas fa-envelope input-icon"></i>
        <input
          formControlName="email"
          type="email"
          class="form-control text-lowercase"
          placeholder="Ingrese su email registrado"
          [class.is-invalid]="emailNoValido"
        />
      </div>
      <small *ngIf="emailNoValido" class="error-msg">Email inválido o no completado</small>
    </div>

    <div class="form-group mt-4 mb-4 d-flex justify-content-center">
      <ngx-recaptcha2
        #captchaElem
        [siteKey]="siteKey"
        formControlName="recaptcha"
      >
      </ngx-recaptcha2>
    </div>

    <div class="row g-3">
      <div class="col-6">
        <button [disabled]="!form.valid" type="submit" class="btn-primary">
          <i class="fas fa-sync-alt me-2"></i> Reenviar
        </button>
      </div>
      <div class="col-6">
        <button
          [routerLink]="['/login']"
          class="btn-secondary-outline"
          type="button"
        >
          Cancelar
        </button>
      </div>
    </div>
  </form>
</div>